
















































































































import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import ratingService from '@/evaluations/services/rating-service'
import Score from '@/evaluations/entities/score'
import Evaluation from '@/evaluations/entities/evaluation'
import evaluationService from '@/evaluations/services/evaluation-service'
import Candidate from '../entities/candidate'
import Strings from '@/app/utils/strings'
import sumBy from 'lodash/sumBy'
import {
  Chart,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Legend,
  ScriptableScaleContext,
} from 'chart.js'
import { AnyObject } from 'chart.js/types/basic'

@Component
export default class CandidateRadar extends Vue {
  @Prop({ type: String })
  private evaluationId!: string

  @Prop({ type: String })
  private candidateId!: string

  @Prop({ type: Boolean, default: false })
  private hideTable!: boolean

  @Prop({ type: Boolean, default: false })
  private hideRadar!: boolean

  @Ref()
  private canvas!: HTMLCanvasElement

  @Ref()
  private canvasZoomed!: HTMLCanvasElement

  private chart!: Chart<'radar', number[], string>

  private loading = false

  private dialog = false
  private dialogOpened = false

  private evaluation!: Evaluation
  private candidate: Candidate = new Candidate()
  private candidateRatings: Score[] = []

  private competenceLabels: any[] = []
  private targetScores: number[] = []
  private candidateScores: number[] = []

  @Watch('candidateId')
  private async candidateChanged() {
    await this.loadData()
  }

  private resetScores() {
    this.competenceLabels = []
    this.targetScores = []
    this.candidateScores = []
  }

  private get totalSum() {
    return sumBy(this.candidateRatings, 'total')
  }

  private get netTotalSum() {
    return sumBy(this.candidateRatings, 'netTotal')
  }

  private get bonusSum() {
    return sumBy(this.candidateRatings, 'bonus')
  }

  private async loadData() {
    this.resetScores()

    const evaluation = await evaluationService.findOneAsync(this.evaluationId)
    if (evaluation != null) {
      this.evaluation = evaluation
    }

    this.evaluation.competences.forEach((element) => {
      this.competenceLabels.push(Strings.formatLabel(element.title, 20))
    })

    this.evaluation.competences.forEach((element) => {
      this.targetScores.push(element.rating)
    })

    var filterRes = this.evaluation.candidates.filter(
      (c) => c.id == this.candidateId
    )
    if (filterRes.length > 0) {
      this.candidate = filterRes[0]
    }

    const res = await ratingService.findForCandidate(
      this.evaluationId,
      this.candidateId
    )
    if (res != null) {
      this.candidateRatings = res
    }

    this.evaluation.competences.forEach((element) => {
      var filterRatings = this.candidateRatings.filter(
        (r) => r.competenceId == element.id
      )
      if (filterRatings.length > 0) {
        this.candidateScores.push(filterRatings[0].total ?? 0)
      } else {
        this.candidateScores.push(0)
      }
    })

    this.chart.data.datasets[0].data = this.targetScores
    this.chart.data.datasets[0].label = 'SOLL'
    this.chart.data.datasets[1].data = this.candidateScores
    this.chart.data.datasets[1].label = 'IST (Gesamt)'
    this.chart.data.labels = this.competenceLabels
    this.chart.update()
  }

  private get headers() {
    return [
      {
        text: this.$tc('common.competence'),
        value: 'competenceName',
        sortable: true,
      },
      {
        text: this.$tc('evaluations.models.score.target'),
        value: 'target',
        sortable: true,
        align: 'end',
      },
      {
        text: this.$tc('evaluations.models.score.total'),
        value: 'total',
        sortable: true,
        align: 'end',
      },
      {
        text: this.$tc('evaluations.models.score.netTotal'),
        value: 'netTotal',
        sortable: true,
        align: 'end',
      },
      {
        text: this.$tc('evaluations.models.score.bonus'),
        value: 'bonus',
        sortable: true,
        align: 'end',
      },
      {
        text: this.$tc('evaluations.models.score.discrepancy'),
        value: 'discrepancy',
        sortable: true,
        align: 'end',
      },
    ]
  }

  private downloadRadar() {
    this.$emit('downloadRadar', this.candidateId)
  }

  private openDialog() {
    this.dialog = true
    if (!this.dialogOpened) {
      Vue.nextTick(() => {
        const ctx = this.canvasZoomed.getContext('2d')
        if (ctx) {
          // @ts-ignore
          this.chart = this.getChart(ctx, 3, 15)
          this.dialogOpened = true
        }
      })
    }
  }

  private getChart(
    ctx: CanvasRenderingContext2D,
    lineBorderWidth = 1,
    fontSize = 12
  ) {
    return new Chart(ctx, {
      type: 'radar',
      data: {
        labels: this.competenceLabels,
        datasets: [
          {
            label: 'SOLL',
            data: this.targetScores,
            fill: false,
            backgroundColor: 'rgba(0, 168, 0, 0.2)',
            borderColor: 'rgb(0, 168, 0)',
            pointBackgroundColor: 'rgb(0, 168, 0)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(0, 168, 0)',
          },
          {
            label: 'IST',
            data: this.candidateScores,
            fill: false,
            backgroundColor: 'rgba(168, 0, 0, 0.2)',
            borderColor: 'rgb(168, 0, 0)',
            pointBackgroundColor: 'rgb(168, 0, 0)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(168, 0, 0)',
          },
        ],
      },
      options: {
        elements: {
          line: {
            borderWidth: lineBorderWidth,
          },
        },
        scales: {
          r: {
            min: 0,
            max: 7,
            grid: {
              color: 'rgb(0, 0, 0, 0.25)',
            },
            pointLabels: {
              color: 'rgb(0, 0, 0)',
              font: { size: fontSize },
            },
          },
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              font: { size: 14 },
              boxHeight: 2,
            },
          },
        },
      },
    })
  }

  private async mounted() {
    Chart.register(RadarController)
    Chart.register(BarElement)
    Chart.register(BarController)
    Chart.register(CategoryScale)
    Chart.register(LinearScale)
    Chart.register(RadialLinearScale)
    Chart.register(PointElement)
    Chart.register(LineElement)
    Chart.register(Legend)

    const ctx = this.canvas.getContext('2d')
    if (ctx) {
      // @ts-ignore
      this.chart = this.getChart(ctx, 2, 12)
    }

    await this.loadData()
  }
}
